import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageEmployeeLayer from "../../../components/Admin/ManageEmployeeLayer";

const ManageEmployee = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageEmployeeLayer />
      </MasterLayout>
    </>
  );
};

export default ManageEmployee;